"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionLink = exports.ActionLinkDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var use_icons_1 = require("../../hooks/use-icons");
exports.ActionLinkDefaultProps = {
  dir: 'forward',
  target: '_self',
  color: 'dark',
  invert: false,
  hoverColor: 'primary'
};
// -------- Styles -------->
var ActionLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-decoration: none;\n    font-weight: 500;\n    font-family: ", ";\n    display: inline-block;\n  "], ["\n    text-decoration: none;\n    font-weight: 500;\n    font-family: ", ";\n    display: inline-block;\n  "])), theme_1.theme.FONT('sans'))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1em;\n\n    ", "\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1em;\n\n    ", "\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  "])), function (props) {
    return props.color !== 'none' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n      color: ", ";\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "], ["\n      ", ";\n      color: ", ";\n      &:hover {\n        ", ";\n        color: ", ";\n      }\n    "])), theme_1.theme.FILL(props.color), theme_1.theme.COLOR(props.color), theme_1.theme.FILL(props.hoverColor), theme_1.theme.COLOR(props.hoverColor));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: ", ";\n  "], ["\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ActionLinkStyles),
  Link: (0, styled_components_1.default)(router_1.Link)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ActionLinkStyles),
  Anchor: styled_components_1.default.a(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ActionLinkStyles),
  Label: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Body: styled_components_1.default.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
var ActionLink = function (props) {
  var children = props.children,
    className = props.className,
    dir = props.dir,
    to = props.to,
    invert = props.invert,
    href = props.href,
    target = props.target;
  var hoverColor = invert ? props.color : props.hoverColor;
  var color = invert ? props.hoverColor : props.color;
  var isLink = Boolean(href || to && to.match(/^mailto/));
  var linkHref = href || isLink && to;
  var _a = (0, use_icons_1.useIcons)(),
    ArrowRightCircle = _a.ArrowRightCircle,
    ArrowLeftCircle = _a.ArrowLeftCircle,
    PlusCircle = _a.PlusCircle;
  var icons = {
    backward: ArrowLeftCircle,
    forward: ArrowRightCircle,
    create: PlusCircle
  };
  var Icon = icons[dir];
  var body = React.createElement(My.Body, {
    color: color,
    hoverColor: href || to ? hoverColor : null
  }, React.createElement(Icon, null), React.createElement(My.Label, {
    dir: dir
  }, children));
  return isLink ? React.createElement(My.Anchor, {
    className: className,
    dir: dir,
    href: linkHref,
    target: target
  }, body) : to ? React.createElement(My.Link, {
    className: className,
    to: to,
    dir: dir
  }, body) : React.createElement(My.Container, {
    className: className,
    dir: dir
  }, body);
};
exports.ActionLink = ActionLink;
exports.ActionLink.defaultProps = exports.ActionLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;